import { PaymentMethod } from "@freightsimple/generated-dashboard-openapi-client/models/PaymentMethod";

// The brands we hold real artwork for. Card brands and the Canadian bank
// institution numbers; anything else falls back to a generic mark.
const BRANDED = new Set([
  "visa",
  "mastercard",
  "amex",
  "001",
  "002",
  "003",
  "004",
  "006",
  "010",
  "016",
  "030",
]);

/**
 * The brand `CardBrandIcon` should draw for a payment.
 *
 * Stripe gives us a card brand or a bank institution number, but only for the
 * ones we have a logo for — everything else (and every non-card method) needs
 * the generic mark for how the customer paid, which is what the payment method
 * decides. Callers hand the result straight to `CardBrandIcon`.
 */
export function paymentsCardBrandFor(
  brand: string | undefined,
  paymentMethod: PaymentMethod | undefined,
): string {
  if (brand !== undefined && BRANDED.has(brand)) {
    return brand;
  }

  switch (paymentMethod) {
    case PaymentMethod.BankAccount:
      return "generic-bank";
    case PaymentMethod.Cash:
      return "cash";
    case PaymentMethod.Cheque:
      return "cheque";
    case PaymentMethod.Eft:
      return "eft";
    case PaymentMethod.InteracETransfer:
      return "interac-etransfer";
    case PaymentMethod.Wire:
      return "wire";
    case PaymentMethod.CreditCard:
    case undefined:
      return "generic-credit-card";
  }
}
